import { useState, useEffect } from 'react';
import { Background, Form, Title, Button, CloseIcon } from './style';
import SelectLabel from '../../../SelectLabel';
import api from '../../../../services/api';
import { Swal } from '../../../../services/SwalTemplates';
import { userId } from '../../../../services/TokenData';
import TextareaLabel from '../../../TextareaLabel';
import Texts from '../../../../assets/json/texts.json';
import { add } from '../../../../services/DateFormatter';
import alert from '../../../../utils/alert'

export default function EditSolicitacao({ Show, setShow, DadosSolicitacao, setReload, Reload }) {
    const [Motivo, setMotivo] = useState('');
    const [Situacao, setSituacao] = useState('');
    const USER_ID = userId();

    // Função para resetar os dados do formulário
    const resetFormData = () => {
        setMotivo('');
        setSituacao('');
    };

    // Função para carregar os dados iniciais
    const loadInitialData = () => {
        if (DadosSolicitacao) {
            setMotivo(DadosSolicitacao?.motivo_situacao || '');
            setSituacao(DadosSolicitacao?.situacao || '');
        }
    };

    // useEffect para controlar abertura/fechamento do modal
    useEffect(() => {
        if (Show && DadosSolicitacao) {
            // Modal está abrindo - carregar dados
            loadInitialData();
        } else if (!Show) {
            // Modal está fechando - resetar dados
            resetFormData();
        }
    }, [Show, DadosSolicitacao]);

    async function HandleSubmit(e) {
        e.preventDefault();

        if (Situacao === 'Selecione uma situação' || Situacao === 'Aguardando') {
            Swal.fire({
                title: 'Atenção!',
                text: 'Por favor, altere a situação da solicitação.',
                icon: 'error',
            });
            return;
        }

        const data = {
            situacao: Situacao,
            motivo_situacao: Motivo === '' ? 'Não foi especificado o motivo.' : Motivo,
            id_solicitacao: DadosSolicitacao.id,
            seq_ocorrencia: DadosSolicitacao.seq_ocorrencia,
            id_processo: DadosSolicitacao.id_processo,
            id_usuario_acao: USER_ID,
            id_destinatario: DadosSolicitacao.id_solicitante,
        };

        try {
            if (Situacao === 'Aprovada') {
                if (data.seq_ocorrencia === null) {
                    try {
                        const response = await api.get(`/processos/${DadosSolicitacao?.id_processo}`);
                        const dadosProcesso = {
                            id: response.data.processos.id,
                            assunto: response.data.processos.assunto,
                            responsavel: response.data.processos.responsavel,
                            situacao: response.data.processos.situacao,
                            dias_previstos: Number(response.data.processos.dias_previstos) + Number(DadosSolicitacao.quantidade_dias),
                            data_inicio: response.data.processos.data_inicio,
                            data_conclusao: response.data.processos.data_conclusao,
                            data_espera: response.data.processos.data_espera,
                            dias_para_amarelo: response.data.processos.dias_para_amarelo,
                            dias_para_vermelho: response.data.processos.dias_para_vermelho,
                            id_usuario_acao: userId(),
                        };

                        await api.patch(`/processos/${DadosSolicitacao?.id_processo}`, {
                            data: dadosProcesso,
                        });
                    } catch (error) {
                        console.log(error);
                        Swal.fire({
                            title: 'Atenção!',
                            text: 'Erro ao atualizar processo',
                            icon: 'error',
                        });
                        return;
                    }
                } else {
                    try {
                        const response = await api.get(
                            `/ocorrencias/${DadosSolicitacao?.id_processo}/${DadosSolicitacao?.seq_ocorrencia}/${DadosSolicitacao?.nivel_ocorrencia}`
                        );

                        const dadosOcorrencia = {
                            descricao: response.data.ocorrencias_processo[0].descricao,
                            data_conclusao: response.data.ocorrencias_processo[0].data_conclusao,
                            situacao: response.data.ocorrencias_processo[0].situacao,
                            data_prevista: add({
                                DataInicial: response.data.ocorrencias_processo[0].data_prevista,
                                Valor: DadosSolicitacao.quantidade_dias,
                                FormatoValor: 'D',
                            }),
                            resposta: response.data.ocorrencias_processo[0].resposta,
                            resposta_anterior: response.data.ocorrencias_processo[0].resposta,
                            id_processo: response.data.ocorrencias_processo[0].id_processo,
                            seq_ocorrencia: response.data.ocorrencias_processo[0].seq_ocorrencia,
                            nivel_ocorrencia: response.data.ocorrencias_processo[0].nivel_ocorrencia,
                            id_destinatario: response.data.ocorrencias_processo[0].id_destinatario,
                            id_usuario_acao: USER_ID,
                        };

                        await api.patch(
                            `/ocorrencias/${DadosSolicitacao?.id_processo}/${DadosSolicitacao?.seq_ocorrencia}/${DadosSolicitacao?.nivel_ocorrencia}`,
                            {
                                data: dadosOcorrencia,
                            }
                        );
                    } catch (error) {
                        console.log(error);
                        Swal.fire({
                            title: 'Atenção!',
                            text: 'Erro ao atualizar ocorrência',
                            icon: 'error',
                        });
                        return;
                    }
                }
            }

            const finalResponse = await api.patch(`/solicitacoes/${DadosSolicitacao?.id}`, { data });

            // Enviar email
            await api.post(`/user/mail_solicitacao/gestor`, { data });

            // Sucesso
            // Swal.fire({
            //     title: 'Sucesso!',
            //     text: finalResponse?.data?.success || 'Solicitação atualizada com sucesso!',
            //     icon: 'success',
            //     confirmButtonColor: 'var(--main-color)',
            // });
            alert("Sucesso-popup",`${finalResponse?.data?.success || 'Solicitação atualizada com sucesso!'}`,3000,"","","top-end","fit-content")

            // Fechar modal e recarregar dados
            closeModal();
        } catch (error) {
            console.log(error);
            Swal.fire({
                title: 'Atenção!',
                text: 'Erro ao processar solicitação',
                icon: 'error',
            });
        }
    }

    function closeModal() {
        resetFormData();
        setShow(false);
        setReload(!Reload);
    }

    return (
        <Background Show={Show}>
            <Form onSubmit={HandleSubmit}>
                <CloseIcon onClick={closeModal} />
                <Title>{Number(DadosSolicitacao?.id_solicitante) === USER_ID ? 'Solicitação encaminhada' : 'Editar Solicitação'}</Title>
                <div className="infoSol">
                    <p>
                        <strong>Processo: </strong> {DadosSolicitacao?.numero_processo}
                    </p>
                    <p>
                        <strong>Ocorrência: </strong> {DadosSolicitacao?.seq_ocorrencia || 'N/D'}
                    </p>
                    <p>
                        <strong>Solicitante: </strong> {DadosSolicitacao?.solicitante}
                    </p>
                    <p>
                        <strong>Data da Solicitação: </strong> {DadosSolicitacao?.data_solicitacao}
                    </p>
                    <p>
                        <strong>Dias solicitados: </strong>
                        {DadosSolicitacao?.quantidade_dias}
                    </p>
                    <p>
                        <strong>Data Prevista Antes da Aprovação: </strong> {DadosSolicitacao?.data_prevista}
                    </p>
                    <p>
                        <strong>Justificativa: </strong>
                        {DadosSolicitacao?.justificativa_solicitacao}
                    </p>
                </div>

                {Number(DadosSolicitacao?.id_destinatario) === USER_ID && (
                    <SelectLabel
                        label="Situação"
                        value={Situacao}
                        onChange={(e) => setSituacao(e.target.value)}
                        defaultValue={Texts?.STATIC_OPC_SITUACAO_SOLICITACAO[0]}
                        options={Texts?.STATIC_OPC_SITUACAO_SOLICITACAO}
                        values={Texts?.STATIC_OPC_SITUACAO_SOLICITACAO}
                        required={Number(DadosSolicitacao?.id_destinatario) === USER_ID && DadosSolicitacao?.situacao !== 'Aguardando'}
                        disabled={Number(DadosSolicitacao?.id_destinatario) !== USER_ID || DadosSolicitacao?.situacao !== 'Aguardando'}
                        width="85%"
                    />
                )}
                <TextareaLabel
                    label="Motivo"
                    type="text"
                    value={Motivo}
                    onChange={(e) => setMotivo(e.target.value)}
                    required={Number(DadosSolicitacao?.id_destinatario) === USER_ID && Situacao === 'Reprovada'}
                    maxLength={180}
                    disabled={Number(DadosSolicitacao?.id_destinatario) !== USER_ID || DadosSolicitacao?.situacao !== 'Aguardando'}
                    width="85%"
                />

                {Number(DadosSolicitacao?.id_destinatario) === USER_ID && DadosSolicitacao?.situacao === 'Aguardando' && (
                    <Button type="submit">Salvar</Button>
                )}

                <div
                    style={{
                        width: '85%',
                        justifyContent: 'center',
                        display: !(Number(DadosSolicitacao?.id_destinatario) === USER_ID && DadosSolicitacao?.situacao === 'Aguardando')
                            ? 'flex'
                            : 'none',
                    }}
                >
                    <span
                        style={{
                            width: '40%',
                            backgroundColor:
                                DadosSolicitacao?.situacao === 'Aprovada'
                                    ? 'var(--pastel-green)'
                                    : DadosSolicitacao?.situacao === 'Reprovada'
                                      ? 'var(--alerta-vermelho-color)'
                                      : 'var(--table-primary-color)',
                            padding: '15px 20px',
                            borderRadius: '8px',
                            textAlign: 'center',
                            color: 'white',
                            fontWeight: '700',
                        }}
                    >
                        {DadosSolicitacao?.situacao}
                    </span>
                </div>
            </Form>
        </Background>
    );
}
